import { render, staticRenderFns } from "./RaceSelect.vue?vue&type=template&id=3575970e&"
import script from "./RaceSelect.vue?vue&type=script&lang=js&"
export * from "./RaceSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports